<template>
  <div class="first_swiper">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in lunbo.list" :key="item.id">
          <a :href="item.url" class="swiper_img">
            <img
              :src="coverIMG(item.coverImagesList)"
              :alt="item.title"
              class="van-image__img"
              style="object-fit: cover"
              width="100%"
              height="5.7rem"
            />
          </a>
          <div class="first_swiper_text">
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>

    <div class="first_swiper_grey"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import SwiperCore, { Autoplay } from "swiper/core";

import "swiper/swiper-bundle.css";

import { onMounted, computed, nextTick } from "vue";
import { useStore } from "vuex";

import { coverIMG } from "../utils/helper";

SwiperCore.use([Autoplay]);

// 这个组件是等所有加载完以后才会加载
export default {
  setup() {
    let swiper;

    // vuex
    const store = useStore();

    //轮播图信息
    const lunbo = computed(() => {
      return store.state.lun_bo;
    });

    onMounted(() => {
      nextTick(() => {
        swiper = new Swiper(".swiper-container", {
          slidesPerView: "auto",
          loop: true,
          centeredSlides: true,
          // 阻止冒泡
          touchMoveStopPropagation: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            // 自动滑动
            delay: 3000, //1秒切换一次
            disableOnInteraction: false,
          },
        });
      });
    });

    return {
      lunbo,
      coverIMG,
    };
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 700ms;
  flex: none;
  width: 90%;
  transform: scale(0.95);
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.first_swiper_text {
  position: absolute;
  color: #fff;
  font-size: 0.4rem;
  bottom: 10px;
  width: 95%;
  text-align: left;
  line-height: 0.48rem;
  font-weight: bold;
}

.swiper_img {
  display: block;
  width: 100%;
}

.first_swiper_grey {
  width: 100%;
  height: 10px;
  background-color: #f9f9f9;
  margin-top: 5px;
}
</style>